import { getNodeIdComposer } from '@utils';
import { RootPrefix } from '../constants';

export const _id = getNodeIdComposer(RootPrefix, 'services_section');
